import { render, staticRenderFns } from "./serviceRenewRecord.vue?vue&type=template&id=1394be28&scoped=true&"
import script from "./serviceRenewRecord.vue?vue&type=script&lang=js&"
export * from "./serviceRenewRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1394be28",
  null
  
)

export default component.exports